module.exports = {
  SIGNUP: 'SAVECUSTOMER',
  SIGNUP_OTP: 'Sign up otp',
  SIGNUP_OTP_VERIFY: 'Sign up otp verify',
  CURRENCY_CONVERTER: 'Currency converter',
  RECIPIENT_ADDRESS_STATE: 'recipient address state',
  RECIPIENT_ADDRESS_COUNTRY: 'recipient address country',
  PURPOSE_OF_TRANSFER: 'purpose of transfer',
  SOURCE_OF_FUND: 'source of fund',
  RECIPIENT_ADDRESS_CITIZENSHIP: 'citizenship',
  CHECK_RISK_RATING: 'risk rating check',
  GENERATE_CAPTCHA: 'Generate Captcha',
  VERIFY_CAPTCHA: 'Verify Captcha',
  US_CITY: 'US City',
  US_STATE: 'Us State',
  NON_US_STATE_SEARCH: 'Non Us state search',
  NONUS_STATE: 'Non US State',
  COUNTRY_LIST: 'Get country list',
  STATE_LIST_FROM_COUNTRY: 'Get state list from selected country',
  CITIZENSHIP_LIST: 'Get citizenship list',
  INDIVIDUAL_NON_ICICI_BANKS: 'Individual non icici bank',
  INDIVIDUAL_NON_ICICI_BANK_CITY_LIST: 'Individual non icici bank city list',
  INDIVIDUAL_NON_ICICI_BANK_BRANCH_LIST: 'Individual non icici bank city branch list',
  INDIVIDUAL_NON_ICICI_BANK_IFSC_CODE: 'Individual non icici bank ifsc code',
  NEW_RECIPIENT_REQUEST: 'New recipient request list',
  LAST_FIVE_TRANSACTION: 'Last five transaction list',
  RECENT_FAV_TRANSACTION: 'Recent Favorite transaction list',
  RECIPIENT_REQUEST_COUNT: 'Recipient request count',
  CCD_DATA_LIST: 'Ccd Data list',
  UPDATE_CCD_DATA: 'Update Ccd Data',
  FAV_TRANSACTION: 'Favorite transaction list',
  PRE_LOGIN_SERVICES: 'Pre login services',
  RISK_RATING_LOGIN_SERVICES: 'Risk rating login services',
  LOGIN_SERVICES: 'Login services',
  POST_LOGIN: 'Post Login services',

  VERIFY_BANK_ABA_NUMBER: 'Verify bank ABA number',
  VERIFY_BANK_CLEAR_CODE: 'Verify bank clear code',
  MY_REGISTARTION_REFERRALS_STATUS_LIST: 'My registration referrals status list',
  MY_TRANSACTION_REFERRALS_STATUS_LIST: 'My transaction referrals status list',
  MY_RECIPIENT_LIST: 'My recipient list',
  UPDATE_REFARRAL_ID: 'Update refarral id',
  MY_RECIPIENT_REQUEST_LIST: 'My recipient request list',
  SAVE_CONTACT_DETAILS: 'Save contact details',
  MY_BANK_ACCOUNT_LIST: 'My bank account list',
  VERIFY_BANK_DETAILS: 'Verify bank details',
  VERIFY_BANK_STATEMENT: 'Verify bank statement',
  INSTANT_ACCOUNT_VERIFICATION: 'Instant account verification',
  ACCOUNT_YODLEE_VERIFICATION: 'Account yodlee verification',
  VERIFY_TXN: 'Verify TXN',
  ADD_BANK_DETAILS: 'Add bank details',
  GET_PROFILE_DETAILS: 'Get profile details',
  SAVE_PROFILE_DETAILS: 'Save profile details',
  SAVE_D2DPROFILE_DETAILS: 'Save d2d profile details',
  D2D_AFTER_SUBMIT: 'D2D after submit',
  SELECT_RECIPIENT_LIST: 'Select recipient list',
  DUPLICATE_BENENAME_CHECK: 'Duplicate Bene name check',
  DD_PAYABLE_LIST: 'DD payable list',
  MANAGE_BILLERS: 'Manage Billers',
  ACCOUNT_DROPDOWN: 'Select account dropdown',
  ALL_TRANSACTION_LIST: 'All transaction list',
  RECURRING_TRANSACTION: 'Recurring transactions',
  ADD_REMOVE_FAVOURITE: 'Add remove favourite',
  REFERRAL_STATUS_LIST: 'Get referral status list',
  SEND_REFERRAL: 'Send referral request',
  SEND_REFERRAL_REMINDER: 'Send referral request',
  CHANGE_PASSWORD: 'Change password',
  RESET_PASSWORD: 'Reset password',
  FORGOT_PASSWORD: 'Forgot password',
  FORGOT_PASSWORD_NON_US: 'Forgot password non us',
  FORGOT_USERID: 'Forgot user id send otp',
  TRACK_PRE_STATUS: 'Track pre status',
  TRACK_POST_STATUS: 'Track post status',
  MY_BILLER_LIST: 'My biller',
  DONATION_LOCATION: 'Donation location dropdown',
  DONATION_CATEGORY: 'Donation category dropdown',
  REGISTERED_CATEGORY: 'Registered category dropdown',
  DONATION_BENEFICIARY_LIST: 'Donation beneficiary list',
  BANK_NAME_SEARCH: 'Bank name search',
  BANK_CITY_SEARCH: 'Bank city search',
  BANK_LOCATION_SEARCH: 'Bank location search',
  REGISTERED_ENTITY_LIST: 'Registered entity list',
  ADD_BENEFICIARY_LIST: 'Add beneficiary list',
  SEND_OTP_ADD_BENE: 'Send OTP add bene',
  VERIFY_OTP_ADD_BENE: 'Verify OTP add bene',
  PREMIUM_INSURANCE: 'ICICI premium insurance',
  SAVE_DETAILS: 'save details',
  SAVE_LEAD_CUSTOMER: 'save lead details',
  LOGOUT: 'logout',
  CONFIRM_PRE_RECURRING_TRANSACTION: 'Confirm Pre Recurring transaction',
  CONFIRM_PRE_ONE_TIME_TRANSACTION: 'Confirm Pre One Time transaction',
  CONFIRM_POST_TRANSACTION: 'Confirm Post One Time transaction',
  TransactionSendOtp: 'Transaction Send Otp',
  TransactionVerifyOtp: 'TRansaction Verify Otp',
  EXPRESS_DELIVERY: 'express delivery',
  SEND_MONEY_ACTION: 'send money action',
  PROMO_CODE: 'promo code',
  ADD_BILLERS: 'Add billers',
  ADD_LANDLINE: 'Add landline',
  SAVE_REGISTERED_BILLER: 'Save registered biller service',
  SAVE_PRESENTMENT_BILLER: 'Save presentment biller service', // ActSavePresentMentBillerService
  BILLING_STATUS_VIEW_DETAILS: 'Billing status view details',
  CONFIRM_PAY_OTP: 'Confirm Pay OTP',
  MY_REWARDS_LIST: 'My rewards list',

  VIEW_ALL_NOTIFICATIONS: 'View All notifications',
  READ_NOTIFICATIONS: 'Read Notificatins',
  View_Reciept: 'View Reciept',
  TRANSACTION_SEND_OTP: 'Transaction Send Otp',
  TRANSACTION_VERIFY_OTP: 'TRansaction Verify Otp',

  // add -recpient
  IFSC_CHECK: 'ifsc check',
  ADD_RECIPIENT_IND_ICICI: 'add recipient ind icici',
  ADD_RECIPIENT_IND_NONICICI: 'add recipient ind non icici',
  ADD_RECIPIENT_BUS_NONICICI: 'add recipient bus non icici',
  ADD_RECIPIENT_BUS_ICICI: 'add recipient bus icici',

  UPLOAD_DOCUMENTS: 'upload documents',
  BUSINESS_LNSUCCESS_CHECK: 'business linsuccess check',
  BUSINESS_LNFAILURE_CHECK: 'business linfailure check',
  UPLOAD_DOCUMENTS_INDIVIDUAL: 'upload documents individual',
  AUTH_TOKEN: 'authorization token',
  DELETE_MY_ACCOUNTS: 'delete my accounts',
  INITIATE_MY_ACCOUNTS: 'initiate my accoutns',
  OTP_STATUS: 'OTP status',
  EST_DELIVERY_DATE: 'Estimated delivery date',
  LAST_TRANSACTION_PURPOSECODE: 'Last transaction pupose code',
  GET_TOKEN: 'Get Token',
  GetPurposePopUp: 'Get purpose pop up',
  GetPurposePopDec: 'Get purpose pop dec',
  SUB_DOLLAR_VERIFICATION: 'sub dollar verification',
  APPLY_GOLD_MEMBERSHIP: 'apply gold membership',
  CSRF_TOKEN: 'csrf token',
  SSN_CHECK: 'ssn check',
  REMITTER_ACCOUNT_CHECK: 'remitter ac check',
  REMITTER_ACCOUNT_CHECK_UK: 'remitter ac check uk',
  BENEFICIARY_ACCOUNT_CHECK: 'beneficiary ac check',
  POST_CALCULATION: 'post calculation',
  MPIN_CHANGES: 'change Mpin',
  MPIN_SAVE: 'Set Mpin',
  MPIN_SENDOTP: 'Mpin send otp',
  MPIN_VERIFYOTP: 'Mpin verify otp',
  MPIN_EXIST: 'check mpin exist or not',
  MPIN_FORGET_DETAILS: 'forget mpin detail',
  MPIN_FORGET_USERID: 'forget mpin userId',
  CHECK_ACCNUM_VALID: 'Check acc num valid or not',
  CHECK_TOUCH_ID_EXIST: 'Check touch id exist',
  UPDATE_TOUCH_ID: 'Update touch id',
  APP_VERSION_CHECK: 'app version check',
  POWER_DOCUMENT_REVIEW: 'Power document review',
  UPLOAD_POWER_DOCUMENT: 'Upload power document',
  SSO_REGISTRATION: 'sso registration',
  SSO_LOGIN: 'sso login',
  SSO_HOME: 'sson home',
  SUB_PURPOSE_TRANSFER: 'sub purpose transfer',
  BENEFICIARY_RECIPIENT_NICKNAME_CHECK: 'beneficiary recipient nickname check',
  BENEFICIARY_RECIPIENT_NICKNAME_CHECK_UK: 'beneficiary recipient nickname check for UK',
  CHECK_NICK_NAME: 'Check nick name',
  PROFILE_OTP: 'profile mobile num otp',
  PROFILE_VERIFY_OTP: 'profile verify otp',
  TRACK_TRANSACTION_OTP: 'track otp',
  TICKER_TEXT: 'ticker_text',
  LOGIN_TICKER_TEXT: 'ticker_text_after_login',
  VERIFY_OTP_D2D: 'verify otp d2d',
  SEND_OTP_D2D: 'send otp d2d',
  CREATE_PASSWORD_D2D: 'create password d2d',
  ADD_YODLEE_FLAG: 'add_yodlee_flag',

  SET_CUSTOMER_TEMPORARY: 'set customer temporary',
  BENELIMITCHECK: 'Bene limit check',
  ACHLIMITCHECK: 'ach limit check',
  //signup individual

  GET_ABOUT_US: 'get about us',
  POST_ABOUT_US: 'post about us',
  GET_CURRENT_ADDRESS: 'get current address',
  POST_CURRENT_ADDRESS: 'post current address',

  //signup individual

  GET_ABOUT_BUSINESS: 'get about BUSINESS',
  POST_ABOUT_BUSINESS: 'post about BUSINESS',
  GET_AUTHORIZED_PERSON_ADDRESS: 'get authorized person address',
  POST_AUTHORIZED_PERSON_ADDRESS: 'post authorized person address',
  GET_AUTHORIZED_PERSON: 'get authorized person ',
  POST_AUTHORIZED_PERSON: 'post authorized person ',
  GET_BUSINESS_ADDRESS: 'get authorized person ',
  POST_BUSINESS_ADDRESS: 'post authorized person ',

  //send feedBack
  POST_SEND_FEEDBACK: 'post send feedback',

  //D2D profile
  SEND_D2D_OTP: 'send d2d otp',
  VERIFY_D2D_OTP: 'verify d2d otp',
  D2D_CONFIRM: 'Act Confirm Details Verify',
  D2D_CONFIRM_MIG: 'Act Confirm Details Aft Mig',

  //slab rate
  SLAB_RATE: 'Slab rate',

  //uk consent
  UK_CONSENT: 'Uk consent',

  // temporary purpose
  AUTH_KEY: 'Bearer eyJhbGciOiJIUzI1NiJ9.eyJqdGkiOiJjZTcyNmZlNC1lOTg1LTRjM2QtODAzYS1jMzYwZTAxNWQwMGMiLCJpc3MiOiJodHRwOi8vZXhhbXBsZS5vcmciLCJhdWQiOiJodHRwOi8vZXhhbXBsZS5vcmciLCJzdWIiOiJyYWplc2guc3V2YXJuYUBuaXZldXNzb2x1dGlvbnMuaW4iLCJpYXQiOjE1NzU5NzI5NzYsImV4cCI6MTU3NTk3MzI3NiwicmVmcmVzaENvdW50IjowLCJyZWZyZXNoTGltaXQiOjF9.-vJa3vYZ7UhAziOHud5oSorumXlKrMv-cc2xZV4hBNs'
};
